import * as React from 'react'
import { Divider, Grid, Typography } from '@mui/material'

export const FormDivider = ({ show, text, md, className = '' }) => {
  return (
    <Grid item xs={12} md={md} className='FormDivider'>
      {show && (
        <Divider textAlign='left' component='div' className={className}>
          {text && <Typography variant='h6'>{text}</Typography>}
        </Divider>
      )}
    </Grid>
  )
}
